import fetch from './fetch'

/**
 * 获取扎堆专题列表数据
 * @param {Object} params 参数
 * @param {String} params.channel_id 【必须】 扎堆专题id
 * @param {String} params.next_pk 下一篇文章id，除第一次外，后面都要传，后端会返回
 * @param {Number} params.timestamp 时间戳，除第一次外，后面都要传，后端会返回
 * @param {Number} params.last_time 上一次请求时间，除第一次外，后面都要传，后端会返回
 * @param {Number} params.page 页码，除第一次外，后面都要传，后端会返回
 */
export function getFlockData (params) {
  return fetch.exec('/zd_channel_list', params)
}

/**
 * 扎堆踩和赞行为
 * @param {Object} params 参数
 * @param {String} params.channel_id 扎堆专题id
 * @param {String} params.pk 文章id
 * @param {String} params.action 行为： agree 赞； disagree 踩
 * @param {String} params.discussion_id 社区id
 */
export function flockBehavior (params) {
  return fetch.exec('/zd_flock_behavior', params)
}

/**
 * 扎堆组织加入|退出
 * @param {Object} params 参数
 * @param {String} params.channel_id 扎堆专题id
 * @param {String} params.action 行为： join 加入； quit 退出
 */
export function subscribeFlock (params) {
  return fetch.exec('/zd_subscribe_organization', params)
}


/**
 * 扎堆文章(短视频)详情
 * @param {Object} param 参数
 * @param {String} param.article_pk 文章pk
 * @param {String} param.open_type 打开方式
 */
export function getArticleDetail (param) {
  return fetch.exec('/zd_article_detail', param)
}

/**
 * 扎堆帖子详情
 * @param {Object} param 参数
 * @param {String} param.post_id 帖子id
 * @param {String} param.discussion_id 社区id
 */
export function getPostDetail (param) {
  return fetch.exec('/zd_community_post_detail', param)
}

/**
 * 屏蔽媒体
 * @param {Object} param 参数
 * @param {String} param.channel_id 扎堆专题id
 * @param {String} param.pulled_black_name 作者姓名
 * @param {String} param.pulled_black_uid 作者id
 * @param {String} param.type 类型 article 文章 post 帖子
 */
export function blockMedia (param) {
  return fetch.exec('/zd_pull_black', param)
}

/**
 * 扎堆帖子删除
 * @param {Object} param 参数
 * @param {String} param.discussion_id 社区id
 * @param {String} param.post_id 帖子id
 */
export function deletePost (param) {
  return fetch.exec('/zd_community_post_option', param)
}

/**
 * 扎堆作者频道内容列表
 * @param {Object} param 参数
 * @param {String} params.channel_id 扎堆专题id
 * @param {String} params.block_channel_id author_open_info 里的author_app_id字段
 * @param {String} params.author author_open_info 里的author字段
 * @param {String} params.author_id author_open_info 里的author_id字段
 * @param {String} params.next_pk 下一篇文章id，除第一次外，后面都要传，后端会返回
 * @param {Number} params.last_time 上一次请求时间，除第一次外，后面都要传，后端会返回
 * @param {Number} params.page 页码，除第一次外，后面都要传，后端会返回
 */
export function columnList (param) {
  return fetch.exec('/zd_block_flock_list', param)
}

/**
 * 收藏内容（包含文章、帖子、短视频）
 * @param {Object} params 
 * @param {String} params.type flock => 扎堆内容
 * @param {String} params.collection_id 文章id   短视频id   帖子id
 * @param {String} params.action 收藏 add .取消收藏remove
 */
export function collectionLike (param) {
  return fetch.exec('/collection_like', param)
}

/** 扎堆首页列表
 * @param {Object} param 参数
 * @param {String} param.next_id 下一页id
 * @param {String} param.page 页码
 * @param {String} param.type 列表类型 'recommend' 推荐； 'join' 加入； 'review' 看过
 */
export function homeList (param) {
  return fetch.exec('/discovery_tab_list', param)
}

/** 获得压缩字体
 * @param {Object} param 参数
 * @param {String} param.font 【必需】字体名称
 * @param {String} param.content 【必需】压缩字体的内容
 * @param {String} param.font_famliy 字体描述
 */
export function fontmin (param) {
  return fetch.exec('/fontmin', param, { method: 'POST' })
}

/** 获取热门搜索
 */
export function hotSearch () {
  return fetch.exec('/hot_search', {})
}

/** 搜索关键字
 * @param {Object} param 参数
 * @param {String} param.keywords 【必需】encodeUriComponent之后的关键字
 * @param {Object} param.offset 【必需】查询列表位置，每次请求将返回的数字，在下一次请求带上即可
 */
export function search (param) {
  return fetch.exec('/keywords_search', param)
}